import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet, NavLink } from 'react-router-dom';
import { FaTruck, FaHome, FaFileInvoice, FaEnvelope, FaBriefcase, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';
import { logout, isAuthenticated } from '../../services/adminAuth';
import './AdminDashboard.css';

function AdminDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="admin-dashboard">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="admin-sidebar-header">
          <FaTruck className="sidebar-logo" />
          <h2>V&R Courier</h2>
          <p>Admin Panel</p>
        </div>

        <nav className="admin-nav">
          <NavLink to="/admin/dashboard" end className={({ isActive }) => isActive ? 'active' : ''}>
            <FaHome /> <span>Dashboard</span>
          </NavLink>
          <NavLink to="/admin/dashboard/quotes" className={({ isActive }) => isActive ? 'active' : ''}>
            <FaFileInvoice /> <span>Quotes</span>
          </NavLink>
          <NavLink to="/admin/dashboard/contacts" className={({ isActive }) => isActive ? 'active' : ''}>
            <FaEnvelope /> <span>Contacts</span>
          </NavLink>
          <NavLink to="/admin/dashboard/careers" className={({ isActive }) => isActive ? 'active' : ''}>
            <FaBriefcase /> <span>Careers</span>
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            <FaSignOutAlt /> <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="admin-main">
        <header className="admin-header">
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            {sidebarOpen ? <FaTimes /> : <FaBars />}
          </button>
          <h1>V&R Courier Ltd - Admin Dashboard</h1>
          <div className="admin-user-info">
            <span>Admin</span>
          </div>
        </header>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminDashboard;

